import React from 'react';
import Image from 'src/components/docs/Image';
import cx from 'classnames';
import ChevronS2Right from 'plaid-threads/Icons/ChevronS2Right';

import styles from './index.module.scss';
import imageStyles from 'src/components/docs/Image/index.module.scss';

interface Props {
  imageSrc: string;
  imageAlt?: string;
  isCommunity?: boolean;
  name: string;
  description: string;
  url: string;
  width?: string;
  height?: string;
}

const Library: React.FC<Props> = (props: Props) => {
  return (
    <a
      className={cx(styles.library, props.isCommunity && styles.community)}
      href={props.url}
      target='_blank'
      rel='noopener'
    >
      <div className={styles.platform}>
        {props.imageSrc && (
          <Image
            className={imageStyles.maxWidthInitial}
            src={props.imageSrc}
            alt={props.imageAlt || `${props.name} logo`}
            width={props.width}
            height={props.height}
            noMarginBottom
          />
        )}
        <h4 className={styles.platformText}>{props.name}</h4>
      </div>
      <p className={styles.description}>{props.description}</p>
      <ChevronS2Right className={styles.caret} />
    </a>
  );
};

Library.displayName = 'Library';
export default Library;
